/**
 * Legacy module — preserved empty (deps kept) so
 * `acme.common.service.posConfigPages` keeps resolving. Real impl (internal
 * sub-service of PosConfigService, not downgrade-registered):
 *   apps/b2b-frontend/app/core/pos-config/pages/pos-config-pages.service.ts
 * The Angular 18 class replaces the legacy `uuid2` dependency with the `uuid`
 * package. Wave 3 item #17.
 */
angular.module('acme.common.service.posConfigPages', ['angularUUID2']);
